<script setup lang="ts">
import { stringifyQuery } from 'vue-router'

import type { LinkNavTab } from '@shared/ui/menus'

import { AppRoute } from '@shared/config'
import { NavigationLinkTabs } from '@shared/ui/menus'

defineOptions({
  name: 'TasksKanbanMenu',
})

const route = useRoute()

const appendQuery = (url: AppRoute): string => {
  if (url && Object.keys(route.query).length) {
    return `${url}?${stringifyQuery(route.query)}`
  } else {
    return url
  }
}

const config = computed<LinkNavTab[]>(() => [
  {
    text: 'Support',
    to: appendQuery(AppRoute.TasksKanbanSupport),
    selected: route.path === AppRoute.TasksKanbanSupport,
    disabled: false,
    visible: true,
  },
  {
    text: 'Success',
    to: appendQuery(AppRoute.TasksKanbanSuccess),
    selected: route.path === AppRoute.TasksKanbanSuccess,
    disabled: false,
    visible: true,
  },
  {
    text: 'Billing',
    to: appendQuery(AppRoute.TasksKanbanBilling),
    selected: route.path === AppRoute.TasksKanbanBilling,
    disabled: false,
    visible: true,
  },
])

</script>

<template>
  <NavigationLinkTabs :config="config" />
</template>
